export default "__VITE_ASSET__D6PPKcp8__"